import { render, staticRenderFns } from "./imageAnnotationNew.vue?vue&type=template&id=765d5d9a&scoped=true"
import script from "./imageAnnotationNew.vue?vue&type=script&lang=js"
export * from "./imageAnnotationNew.vue?vue&type=script&lang=js"
import style0 from "./imageAnnotationNew.vue?vue&type=style&index=0&id=765d5d9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765d5d9a",
  null
  
)

export default component.exports